import React, { useEffect, useState } from "react";
import { useGlobalContext } from "../../hooks/context";
import DonationList from "./DonationList";
import AddMoreItems from "../../components/button/AddMoreItems";
import PaymentButton from "../../components/button/PaymentButton";

const FixedDonation = ({ donation }) => {
  const { addSelectedItem, findSelectedItem } = useGlobalContext();
  const [amount, setAmount] = useState("0.00");
  const [person, setPerson] = useState(0);
  const { id, title, rate } = donation || {};

  useEffect(() => {
    if (id) {
      const selectedItem = findSelectedItem(id);
      const { price, qty } = selectedItem;
      setAmount(price ? String(price) : "0.00");
      setPerson(qty || 0);
    }
  }, [findSelectedItem, id]);

  const increase = () => {
    const updateAmount = Number(amount) + rate;
    setAmount(updateAmount.toFixed(2));
    setPerson(person + 1);
    addSelectedHandler(updateAmount, person + 1);
  };

  const decrease = () => {
    const updateAmount = Number(amount) - rate;
    setAmount(updateAmount.toFixed(2));
    setPerson(person - 1);
    addSelectedHandler(updateAmount, person - 1);
  };

  const addSelectedHandler = (value, qty) => {
    const payload = { id, qty, name: title, price: String(value) };
    addSelectedItem(payload);
  };

  return (
    <div className="bg-[#5B5353] w-full h-[27%] rounded-25 border border-custom-gray-500 absolute bottom-5">
      <div className="px-10 h-full flex flex-col justify-center">
        <div className="pt-4 grid grid-cols-12 gap-x-12">
          <DonationList
            title={title}
            rate={rate}
            person={person}
            increase={increase}
            decrease={decrease}
          />
          <div className="col-span-3 text-center">
            <span className="text-gray-900 font-semibold">Total Amount</span>
            <input
              type="text"
              className="mt-2 shadow-donation w-full px-2.5 py-3.5 bg-white text-gray-900 text-2xl rounded-xl font-bold focus:ring-blue-500 focus:border-blue-500 block"
              disabled
              readOnly
              value={`$ ${amount}`}
            />
          </div>
        </div>
        <div className="flex justify-end">
          <div className="grid grid-cols-2 gap-x-5 ksm:mt-10 kmd:mt-10 kmd:gap-x-8 kxl:mt-16 kxl:gap-x-16">
            <AddMoreItems />
            <PaymentButton />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FixedDonation;
